import React from 'react'
import PropTypes from 'prop-types'
import {IconButton} from 'react-toolbox/lib/button'
import notifyHoc from 'containers/App/Notification/Notify'
import T from 'i18n-react'

import styles from './styles.scss'

const InfoButton = notifyHoc(IconButton)

const DeleteButton = (props) => (
  <InfoButton
    primary
    message={T.translate('pages.profile.notification.delete')}
    icon='delete'
    onClick={props.onClick}
    theme={styles}
  />
)

DeleteButton.propTypes = {
  onClick: PropTypes.func.isRequired
}

export default DeleteButton
